// Translation loading utility
import commonEn from './en/common.json'
import commonAr from './ar/common.json'
import homepageEn from './en/homepage.json'
import homepageAr from './ar/homepage.json'
import servicesEn from './en/services.json'
import servicesAr from './ar/services.json'
import contactEn from './en/contact.json'
import contactAr from './ar/contact.json'
import cartEn from './en/cart.json'
import cartAr from './ar/cart.json'
import equipmentEn from './en/equipment.json'
import equipmentAr from './ar/equipment.json'
import aboutEn from './en/about.json'
import aboutAr from './ar/about.json'
import heroEn from './en/hero.json'
import heroAr from './ar/hero.json'
import inquiryEn from './en/inquiry.json'
import inquiryAr from './ar/inquiry.json'
import authEn from './en/auth.json'
import authAr from './ar/auth.json'
import dashboardEn from './en/dashboard.json'
import dashboardAr from './ar/dashboard.json'
import filtersEn from './en/filters.json'
import filtersAr from './ar/filters.json'
import eventsEn from './en/events.json'
import eventsAr from './ar/events.json'
import marketplaceEn from './en/marketplace.json'
import marketplaceAr from './ar/marketplace.json'
import projectsEn from './en/projects.json'
import projectsAr from './ar/projects.json'
import announcementsEn from './en/announcements.json'
import announcementsAr from './ar/announcements.json'
import eqsEn from './en/eqs.json'
import eqsAr from './ar/eqs.json'
import partnersEn from './en/partners.json'
import partnersAr from './ar/partners.json'
import supplierEn from './en/supplier.json'
import supplierAr from './ar/supplier.json'
import aiEn from './en/ai.json'
import aiAr from './ar/ai.json'

// Import the legacy files to merge with modular approach
import legacyEn from './en.json'
import legacyAr from './ar.json'

// Function to merge translation objects
const mergeTranslations = (legacy: any, modular: any) => {
  const result = { ...legacy }
  
  // Add modular sections
  Object.keys(modular).forEach(key => {
    result[key] = modular[key]
  })
  
  return result
}

// Create final translation objects
export const enTranslations = mergeTranslations(legacyEn, {
  ...commonEn,
  homepage: homepageEn,
  services: servicesEn,
  contact: contactEn,
  cart: cartEn,
  equipment: equipmentEn,
  about: aboutEn,
  hero: heroEn,
  inquiry: inquiryEn,
  auth: authEn,
  dashboard: dashboardEn,
  filters: filtersEn,
  events: eventsEn,
  marketplace: marketplaceEn,
  projects: projectsEn,
  announcements: announcementsEn,
  eqs: eqsEn,
  partners: partnersEn,
  supplier: supplierEn,
  ai: aiEn,
  common: commonEn
})

export const arTranslations = mergeTranslations(legacyAr, {
  ...commonAr,
  homepage: homepageAr,
  services: servicesAr,
  contact: contactAr,
  cart: cartAr,
  equipment: equipmentAr,
  about: aboutAr,
  hero: heroAr,
  inquiry: inquiryAr,
  auth: authAr,
  dashboard: dashboardAr,
  filters: filtersAr,
  events: eventsAr,
  marketplace: marketplaceAr,
  projects: projectsAr,
  announcements: announcementsAr,
  eqs: eqsAr,
  partners: partnersAr,
  supplier: supplierAr,
  ai: aiAr,
  common: commonAr
})

export default {
  en: enTranslations,
  ar: arTranslations
}
